import { combineProviders } from "react-combine-provider";
import { GlobalStateProvider } from "./useGlobalState";

export const StateProvider = combineProviders([GlobalStateProvider]);
